import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";
import {useParams} from "react-router-dom";
import ImageGallery from "react-image-gallery";

export default () => {
    let title = "Сельские усадьбы Agricultural manors";

    const itemsData = [
        {
            id: 1,
            location: 'Брестский район',
            name: 'Усадьба «Калинка»',
            adress: 'Нелипович Юрий и Зоя ул. Фруктовая 8, д. Чернавчицы, Брестский р-н, Брестская обл.',
            phones: [
                '(+375) 162 94-57-81',
            ],
            imgs: [
                require('./../img/ReferenceInformation/AgriculturalManors/2big_image.jpg'),
            ],
            desc: [
                'Усадьба «Калинка» расположена в Брестском районе Брестской области.',
                'Замечательный новый 2-этажный дом с шестью спальнями, всеми удобствами, баней и благоустроенной приусадебной территорией в 20 соток с ухоженными цветниками, садом, огородом. Недалеко от деревни - лес, река. Возможна организация рыбалки, купания, сбор ягод и грибов, пикники, фитованны. Могут быть организованы экскурсионные поездки в Брестскую крепость-герой, экомузей «Берестье», Беловежскую пущу.',
                'В деревне Чернавчицы существовал оборонительный средневековый замок Радзивиллов, известный с XVI в.',
                'Готовы принять 7-9 человек. Радушные хозяева создадут все условия для плодотворного и запоминающего отдыха, который вернет вам силы и придаст новый импульс вашей работе.',
            ],
        },
        {
            id: 2,
            location: 'Брестский район',
            name: 'Усадьба «Медовая поляна»',
            adress: 'Чернецкий Виталий Андреевич д. Збунин, ул. Лесная 10 Брестский р-н',
            phones: [
                '(+375) 162 955-332',
            ],
            imgs: [
                require('./../img/ReferenceInformation/AgriculturalManors/6big_image.jpg'),
            ],
            desc: [
                'Фермерское хозяйство «Медовая поляна» (д. Збунин, Брестский район), находится в 3 км от Белого озера рядом с красивым лесом. До города Бреста - 40 км, до г.п. Домачево - 6 км.',
                'На участке посажен четырехлетний фруктовый сад из карликовых деревьев.',
                'Предлагаем:',
                '• жилье на 3-5 человек, места для палаток;',
                '•дегустацию блюд из экологически чистых с/х продуктов домашнего приготовления (солений, маринадов, салатов, напитков);',
                '• охраняемые закрытые места стоянки автотранспорта;',
                '• мойку, чистку, техобслуживание, мелкий ремонт автомашины, покраску;',
                '• предоставление участка и условий для отдыха (кострище, беседку, стол, стулья, шезлонг);',
                '• офисные услуги (телефон, телефакс, компьютер, пишущую машинку, калькулятор, канцелярские принадлежности);',
                '• выдачу документов, подтверждающих стоимость проживания;',
                '• охоту, рыбалку, пикник, купание, лесные прогулки, сбор ягод и грибов, лекарственных трав, медицинские услуги санатория «Берестье»; уроки садоводства (посадку, прививку, обрезку деревьев и т.п.).',
            ],
        },
        {
            id: 3,
            location: 'Брестский район',
            name: 'Усадьба «Калинка»',
            adress: 'Нелипович Юрий и Зоя ул. Фруктовая 8, д. Чернавчицы, Брестский р-н, Брестская обл.',
            phones: [
                '(+375) 162 94-57-81',
            ],
            imgs: [
                require('./../img/ReferenceInformation/AgriculturalManors/2big_image.jpg'),
            ],
            desc: [
                'Усадьба «Калинка» расположена в Брестском районе Брестской области.',
                'Замечательный новый 2-этажный дом с шестью спальнями, всеми удобствами, баней и благоустроенной приусадебной территорией в 20 соток с ухоженными цветниками, садом, огородом. Недалеко от деревни - лес, река. Возможна организация рыбалки, купания, сбор ягод и грибов, пикники, фитованны. Могут быть организованы экскурсионные поездки в Брестскую крепость-герой, экомузей «Берестье», Беловежскую пущу.',
                'В деревне Чернавчицы существовал оборонительный средневековый замок Радзивиллов, известный с XVI в.',
                'Готовы принять 7-9 человек. Радушные хозяева создадут все условия для плодотворного и запоминающего отдыха, который вернет вам силы и придаст новый импульс вашей работе.',
            ],
        },
        {
            id: 4,
            location: 'Барановичский район',
            name: 'Усадьба «Ласточка»',
            adress: 'Ильина Нина Константиновна д. Ежона, Подгорнянский с/с Барановичский р-н, Брестская обл.',
            phones: [
                '(+375) 1634 43-44-12',
                '(+375) 1634 47-32-59',
            ],
            imgs: [
                require('./../img/ReferenceInformation/AgriculturalManors/3big_image.jpg'),
            ],
            desc: [
                'Усадьба «Ласточка» расположена в Барановичском районе Брестской области.',
                'Деревня окружена лесом - восточной частью реликтовой Беловежской пущи. Все разнообразие лесных даров - к вашим услугам. Обилие грибов и ягод: земляника, черника, малина, брусника. Вместе с хозяйкой - профессиональным врачом - вы можете прогуляться по лесным тропам, собрать лечебные травы и составить себе сборы, которые холодными зимними вечерами напомнят вам о счастливо проведенном лете.',
                'Рядом с деревней протекает река с криничной водой, не замерзающая даже зимой, недалеко озеро Лесное. У гостей есть возможность покататься на лодке, заняться рыбалкой, купанием.',
                'Для желающих можно организовать катание на лошадях, охоту, экскурсии по окрестностям - в Жировичский монастырь, Слоним.',
                'Гости усадьбы будут проживать в деревянном 4-комнатном доме с верандой и террасой, отдельно от хозяйки. На территории участка в 40 соток - сад, цветники, качели, гамак, поляна для волейбола.',
                'Надеемся, что вам понравится в усадьбе «Ласточка» и вы станете ее постоянным гостем.',
            ],
        },
        {
            id: 5,
            location: 'Жабинковский район',
            name: 'Усадьба «Речная»',
            adress: 'Турицын Геннадий. ул. Речная 7, д. Здитово, Жабинковский р-н, Брестская обл.',
            phones: [
                '(+375) 1641 2-43-98 (дом)',
                '(+375) 1641 2-84-38 (раб)',
            ],
            imgs: [
                require('./../img/ReferenceInformation/AgriculturalManors/9big_image.jpg'),
            ],
            desc: [
                'Усадьба расположена в Жабинковском районе Брестской области в 25 км от Бреста, 3 км от железнодорожной станции Жабинка, 4 км от трассы Брест-Москва. Деревня стоит на высоком берегу реки Мухавец, окружена сосновым и березовым лесом.',
                'Хозяева предлагают несколько видов размещения гостей:',
                '• в одном доме (со всеми удобствами) с хозяевами усадьбы - до 4 человек;',
                '• в отдельном домике - «туристском приюте» -до 5 человек;',
                '• в палатках-до 10 человек.',
                'Пребывание в усадьбе запомнится вам навсегда разнообразием предлагаемых мероприятий, а также красотой и чистотой окружающей природы.',
                'Вы сможете:',
                '• порыбачить в реке Мухавец, где ловится щука, окунь, плотва, сом, жерех;',
                '• совершить геологическую экскурсию и собрать кремний и янтарь;',
                '• в ходе прогулок по лесу увидеть дубы-великаны, которым исполнилось 500 лет, веймутовуг сосну и другие уникальные растения;',
                '• прокатиться на лодке или в конной повозке по окрестностям;',
                '• познакомиться с нашей историей, побывав в Музее «Деревенская хата» (д. Залузье), усадьбе и музее Тадеуша Костюшко, на Крупчицком поле - месте битвы повстанцев с войсками Суворова;',
                '• увидеть за работой мастеров соломоплетения, вышивки, камнерезного дела;',
                '• научиться управлять катамараном, байдаркой, совершить на них водные походы, после которых так приятно посидеть у костра, попариться в русской бане;',
                '• принять участие в сельскохозяйственных работах, заготовить овощи и фрукты на зиму, собрать ягоды и грибы, продегустировать самодельное вино из винограда белорусского сорта «Изабелла».',
            ],
        },
        {
            id: 6,
            location: 'Жабинковский район',
            name: 'Усадьба «Хутор»',
            adress: 'Песецкий Николай. Санаторий «Буг», Жабинковский р-н, Брестская обл.',
            phones: [
                '(+375) 1641 38-1-98',
            ],
            imgs: [
                require('./../img/ReferenceInformation/AgriculturalManors/10big_image.jpg'),
            ],
            desc: [
                'Хозяева предлагают вам отдохнуть на бывшем заброшенном хуторе, на месте которого за несколько лет созданы условия для приема туристов.',
                'Рядом - река Мухавец, озера, лес. У вас есть замечательные возможности для сбора грибов и ягод, купания и активного отдыха.',
                'В пределах 1 км от хутора расположены санатории и дома отдыха, где можно получить платные медицинские процедуры - массаж, подводный массаж, водно-грязевые ванны, иглоукалывание, УЗИ.',
                'Из соседних деревень можно доставлять натуральные продукты: мясо, рыбу, молочные продукты, зелень, мед, овощи, фрукты.',
                'На собственном микроавтобусе, вместительностью 10 человек, можно организовать поездки в:',
                '• Брест - крепость-герой (36 км),',
                '• Беловежскую пущу (76 км),',
                '• Кобрин - музей Суворова (16 км),',
                '• мужской монастырь - Хмелеве (15 км).',
                'Гости могут разместиться в новом кирпичном доме (его внутренняя отделка в «деревянном» стиле приятно удивляет). Есть две спальни, каминный зал и гараж для автомобиля. Кроме того, есть отдельный летний домик из двух комнат и кухни. Естественно, имеется баня-сауна, особенностью которой является оригинальная комната отдыха, расположенная прямо над баней. Замечательно оборудовано место для вечернего отдыха на лоне природы - столики, мангал, коптильня.',
                'До хутора можно добраться железнодорожным транспортом до станции Жабинка или по автотрассе Минск-Брест, недалеко от которой расположена усадьба.',
            ],
        },
        {
            id: 7,
            location: 'Каменецкий район',
            name: 'Усадьба «Лесная»',
            adress: 'Земляник Наталья Николаевна д. Белая 3/1, Каменюкский сельсовет, Каменецкий р-н, Брестская обл.',
            phones: [
                '(+375) 162 56-4-54 (соседи)',
            ],
            imgs: [
                require('./../img/ReferenceInformation/AgriculturalManors/4big_image.jpg'),
            ],
            desc: [
                'Дорогие друзья! Если вы не знаете, где мы находимся, не огорчайтесь. Садитесь в машину и - полный вперед. Проехав 60 км от города Бреста, вы попадете в Беловежскую пущу. Но на этом ваше путешествие не заканчивается, вас ждет еще 6 км сельской дороги до деревни Белая. И вот вы перед воротами усадьбы «Лесная».',
                'Наш дом находится в одном из живописнейших мест национального парка «Беловежская пуща». У нас тишина, почти нетронутая дикая природа. Две маленькие чистые лесные речки, в которых можно ловить рыбу и купаться. Леса богаты грибами, ягодами и лекарственными растениями. А сколько кислорода! Любителей охоты с фотоаппаратом ждут самые неожиданные встречи.',
                'Добраться к нам можно следующим образом. Из Бреста по трассе Р83 нужно проехать 60 км до деревни Каменюки. При въезде в деревню поверните налево (указатель Селищи), далее 6 км по гравийной дороге до деревни Белая. В деревне Белая - первый поворот направо. Наш дом № 3/1.',
                'Хозяйка - Земляник Наталья Николаевна. Мы предлагаем 2-местную комнату в доме с хозяевами. В летний период можем разместить гостей на сеновале (6-8 человек) и в палатках на участке.',
                'Дом деревянный, с печным отоплением. Есть камин. Участок - 50 соток. Колодец во дворе. Удобства (туалет) на улице. Приготовление пищи - хозяевами, с учетом пожеланий гостей.',
                'Домашнее хозяйство - огород, сад, куры, кролики.',
                'В летнее время возможен сбор ягод, грибов, лекарственных растений. Грибы можно высушить в сушилке. Предлагаем также пешеходные прогулки по Беловежской пуще, походы на лыжах зимой, рыбалку - летом, и зимой. Можем организовать экскурсии: в музей и вольеры национального парка «Беловежская пуща», показать местные достопримечательности. Мы приглашаем вас отдохнуть на нашей усадьбе «Лесная»!',
            ],
        },
        {
            id: 8,
            location: 'Каменецкий район',
            name: 'Усадьба «Млынок»',
            adress: 'Грибов Георгий Михайлович д. Млыны, Каменецкий р-н, Брестская обл.',
            phones: [
                '(+375) 162 41-03-65',
                '(+375) 162 42-37-52',
            ],
            email: 'gmgribov@bstu.by',
            imgs: [
                require('./../img/ReferenceInformation/AgriculturalManors/5big_image.jpg'),
            ],
            desc: [
                'Усадьба находится в деревне Млыны Каменецкого района в 35 км от Бреста на берегу реки Лесная. В деревянном доме - две комнаты, кухня и веранда. Есть оборудованный для ночлега сеновал, гараж, место для пикника у костра. После купания в реке можно позагорать на пляже. Вблизи деревни сосновый лес, живописные заливные луга в пойме реки. Гости могут пользоваться байдарками, велосипедами и другим спортивным и туристским инвентарем.',
                'Хозяин усадьбы и его семья - туристы с большим стажем. На их счету более 60 походов и путешествий (пеших, лыжных, водных, велосипедных, автомобильных). Накоплен большой опыт в области семейного туризма и организации походов для гостей из-за рубежа.',
                'Если вы стремитесь отдыхать активно и желаете привить любовь к природе и походам своим детям, если вам интересны история родного края и памятники его культуры, если вам сладок и приятен дым костра и запах сена, если вы не против хоть на время сменить автомобильный руль на велосипедный, а мягкое кресло на сиденье байдарки - приезжайте на отдых в усадьбу «Млынок».',
                'Здесь нет многозвездочного отеля, «звезды» - это:',
                '- пламя костра и душистый сеновал:',
                '- чистая река в кувшинках и белых лилиях плюс золотистый пляж;',
                '- тенистый лес и цветы на лугу;',
                '- соловьиные трели весной, жужжание пчел на цветущей липе и клёкот аистов.',
                'У погоды нет плохой погоды, но если вдруг пойдет дождь, гости могут посмотреть видео- и слайдфильмы, снятые в путешествиях по Беларуси, Прибалтике, России, Кавказу, Уралу, Сибири, Польше, Словакии, Австрии, Германии, Франции, Испании, Португалии, Дании, Швеции. Норвегии, Финляндии и Австралии. В окрестностях деревни можно посетить интересные памятники истории и культуры:',
                '• Национальный парк «Беловежская пуща» и его музей;',
                '• г. Каменец («Белая вежа», Симеоновская церковь нач. ХХв., памятник основателям города);',
                '• г. Высокое (церковь и усадьба XIX в., часовня XVIII в.);',
                '• д. Малые Щитники (Покровская церковь XVIII в., памятный камень мыслителю XVI в. Казимиру Лыщинскому);',
                '• д. Шестаково (усадьба Ромуальда Траугута - руководителя восстания 1863-64 г. г.);',
                '• д. Волчин (Троицкий костел XVIII в., место захоронения последнего короля Речи Посполитой Станислава Понятовского);',
                'д. Тростяница (Преображенская церковь XIXв., захоронения XI-XIII в. в.). Туристические маршруты» организуемые для гостей усадьбы «Млынок» 1. Однодневный поход на байдарках по р. Лесная по маршруту: г. Каменец - д. Млыны (в Каменце посещаются: «Белая вежа», Симеоновская церковь, памятник основателям города).',
                '2. Трехдневный поход на байдарках по р. Лесная по маршруту: п. Каменюки-г. Каменец-д. Млыны (в Каменюках посещается музей» Беловежская пуща», в Каменце - вышеуказанные памятники).',
                '3. Однодневный поход на велосипедах по маршруту: д д. Млыны-Шестаково-Минковичи-Тростяница-Млыны (посещается место усадьбы Ромуальда Траугута - руководителя восстания 1861-1863 гг. и памятный знак; Онуфриевская церковь XIX в. в д. Борщево; Спасо-Преображенская церковь XIX в. в Тростяница, которую в 1888 г. посетил император Александр III с семьей).',
                '4. Однодневный поход на велосипедах по маршруту: д д. Млыны-Остромечево-Малые Щитники-Малые Зводы-Рудовец-Млыны (посещается Покровская церковь XVIII в. в д. М.Щитники и памятный камень в честь мыслителя XVII в. Казимира Лыщинского).',
            ],
        },
        {
            id: 9,
            location: 'Пружанский район',
            name: 'Усадьба «Борки»',
            adress: 'Тарасевич Геннадий д. Борки, Пружанский р-н, Брестская обл.',
            phones: [
                '(+375) 162 41-40-22',
            ],
            imgs: [
                require('./../img/ReferenceInformation/AgriculturalManors/1big_image.jpg'),
            ],
            desc: [
                'Усадьба «Борки» расположена в Пружанском районе Брестской области, в уникальном уголке реликтовой природы Европы - Беловежской пуще.',
                'Настоящее крестьянское подворье гостеприимного хозяина предоставит вам возможность окунуться в сельский быт - принять участие в работе на огороде и в поле, поухаживать за животными (козами, лошадьми, свиньями, курами), испечь хлеб в русской печи.',
                'Хозяин организует прогулки по лесным тропам, сбор ягод и грибов, лекарственных трав. Здоровья и силы прибавит вам знаменитый дуб-целитель, катание на лодках и прогулки в телеге.',
                'Вечером вы сможете посидеть на лесной поляне у костра, поджарить ароматные шашлыки и продегустировать продукцию местного завода. В деревне есть мастера соломоплетения, плетения ковшей, сетей, которые с удовольствием посвятят вас в секреты своего мастерства.',
            ],
        },
        {
            id: 10,
            location: 'Пружаны',
            name: 'Усадьба «Пружанская»',
            adress: 'Шустик Татьяна Александровна ул. Кухарева 9, г. Пружаны',
            phones: [
                '(+375) 1632 2-11-45',
                '(+375) 1632 2-07-46',
            ],
            imgs: [
                require('./../img/ReferenceInformation/AgriculturalManors/8big_image.jpg'),
            ],
            desc: [
                'Усадьба расположена в 35 км от Национального парка «Беловежская пуща», в 15 минутах ходьбы от центра г. Пружаны, рядом с озером и лесом. Пружаны - городок тихий, чистый, много цветов.',
                'Большой дом располагает всеми необходимыми удобствами: холодная и горячая вода, туалет, ванная комната с небольшой сауной. Имеются три спальни, гостиная, кухня и лоджия. Рядом с домом есть времянка с камином, туалетом и баней, гараж, хозяйственные постройки. Во дворе с прекрасным газоном и дорожками - уютная беседка, фонтанчик, стационарная шашлычница, бассейн из камня для купания, качели.',
                'Кроме этого туристам предлагается небольшой домик недалеко от Пружан в деревне Клетное.',
                'По желанию туристов можно организовать катание на конях, охоту, рыбалку, экскурсии в Национальный парк «Беловежская пуща», Каменюки, Ружаны, Пружаны.',
                'Такой отдых придаст вам сил и оставит незабываемые впечатления на целый год.',
                'Приезжайте!',
            ],
        },
    ];

    let get_all_list = (itemsData) => {
        return (
            <ul>
                {itemsData?.map((h) => {
                    const link = "/reference-information-agriculturalmanors/" + h.id;
                    return (<li><a href={link}>{h.location}. {h.name}</a></li>)
                })}

            </ul>
        );
    }

    let get_item = (data) => {
        let result = null;

        if (data.name != undefined) {
            title = data.name;
        }

        let gal = [];
        if (data.gal != undefined) {
            data.gal.map(item => {
                gal.push({
                    original: item.src,
                    thumbnail: item.src,
                    description: item.alt,
                });
            });
        }

        return (
            <>
                {data.adress !== undefined && <p>{data.adress}</p>}
                {data.countItem !== undefined && <p>{data.countItem}</p>}
                {data.phones !== undefined && <ul>{data.phones.map(p => <li>{p}</li>)}</ul>}
                {data.url !== undefined && <a href={data.url}>{data.url}</a>}
                {data.email != undefined && <p>Email: <span>{data.email}</span></p>}
                {gal?.length > 0 &&
                    <div className="two-col-cell">
                        <ImageGallery
                            items={gal}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                }
                {data?.desc?.length > 0 &&
                    data.desc.map(d => <p>{d}</p>)
                }
                {data?.imgs?.length > 0 &&
                    data.imgs.map(i => <img src={i}/>)
                }
            </>
        );
    }

    const params = useParams();

    let view = undefined;
    let nav = get_all_list(itemsData);
    if (params.id != undefined) {
        const id = itemsData.findIndex(e => e.id == params.id);
        if (id == -1) {
            view = get_all_list(itemsData);
        } else {
            console.log('get_item');
            view = get_item(itemsData[id]);
        }
    }

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    {view}
                </div>
                <div className="pageitem">
                    <hr/>
                    {nav}
                </div>
            </div>
        </>
    );
}